import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const isStaleDeployError =
      error?.message?.includes("couldn't load") ||
      error?.message?.includes('page') && error?.message?.includes('undefined') ||
      error?.message?.includes('Loading chunk');

    if (isStaleDeployError && typeof window !== 'undefined') {
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <p>Something went wrong. Reloading...</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
